import { useState } from 'react'
import '../styles/dynamism.scss'
import '../styles/introBox.scss'

//import logo from '../assets/Graphicacy-logo.png'

const IntroBox = () => {
  const [tile, setTile] = useState(false)

  const tileText = (
    <p>
      The term economic dynamism refers to the rate and pervasiveness of change
      across industries, geographies, and the labor market in an economy. Key
      indicators of dynamism traditionally include the rates of business
      formation and closure, the frequency at which workers quit and switch
      jobs, and the propensity of workers and families to move to new locations.
      Economic dynamism is not simply “disruption”; it equates more closely to a
      state of productive churn and adaptation that enables the economy and its
      workers to respond to disruption.
    </p>
  )

  return (
    <div className="dynamism-content">
      {/* interactive layer  */}
      <div className="dynamism-intro">
        <div className={'intro-box'}>
          <div>
            <div className="intro-subtitle">What is</div>
            <div className="intro-title">Dynamism?</div>
          </div>
          <div className="intro-expand" onClick={() => setTile(!tile)}>
            see {tile ? 'less' : 'more'}
          </div>
          <div className={`intro-circle ${tile}`} />
        </div>
        {/* <div className={`solutions-text-mobile ${tile} intro`}>{tileText}</div> */}
        <div className={`intro-text ${tile}`}>{tileText}</div>
      </div>
    </div>
  )
}
export default IntroBox
